import { createMuiTheme } from '@material-ui/core/styles';

export const grisClair = '#f5f6fa';
export const palettePrimary = '#222';
export const grisMoyen = '#a1a1a1';

export const redLight = '#ff4137';
export const redMain = '#ff3f33';
export const primaryBlack = '#1b202d';

export const textHint = '#ff4137';
export const error = '#ff3333';
export const success = '#72de85';

export const gradientRed = 'linear-gradient(62deg, #ff5951 1%, #f02c23 98%)';
export const gradientGris = 'linear-gradient(43deg, #f7f6f6 11%, #d4d5d7 99%)';

export const primaryRed = redMain;

export const theme = createMuiTheme({
  palette: {
    primary: {
      light: grisClair,
      main: palettePrimary,
      dark: grisMoyen,
    },
    secondary: {
      light: redLight,
      main: redMain,
      dark: primaryBlack,
    },
    text: {
      hint: textHint,
    },
    error: {
      main: error,
    },
    success: {
      main: success,
    },
  },
  typography: {
    fontFamily: ['Mulish, sans-serif'].join(','),
    h1: { fontSize: 40, color: redLight, fontFamily: 'Poppins, sans-serif', fontWeight: 600 },
    h2: { fontSize: 33, color: redLight, fontFamily: 'Poppins, sans-serif', fontWeight: 600 },
    h3: { fontSize: 23, color: redLight, fontFamily: 'Poppins, sans-serif', fontWeight: 700 },
    h4: { fontSize: 15, color: primaryBlack, fontFamily: 'Poppins, sans-serif', fontWeight: 700 },
    h5: { fontSize: 14, color: redMain, fontFamily: 'Poppins, sans-serif', fontWeight: 700 },
    body1: { fontSize: 14, color: 'black' },
    body2: { color: grisMoyen },
    button: { fontSize: 17, fontFamily: 'Poppins, sans-serif', fontWeight: 500 },
  },
  overrides: {
    MuiPickersDay: {
      current: {
        color: redMain,
      },
    },
  },
});

export default theme;
